import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListState, PaginationType } from '@typings/requestPayloads'

export interface IListMatchListGroupPayload {
    pagination?: PaginationType
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const listMatchListGroup = createSlice({
    name: 'matchListGroup/list',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IListMatchListGroupPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
            state.pagination = {
                ...state.pagination,
                skip: action.payload.skip,
                total: action.payload.total
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        },
        addToList(state, action) {
            const newData = [...state.data]
            newData.unshift(action.payload.data)
            state.data = newData
        }
    }
})

export const listMatchListGroupActions = listMatchListGroup.actions
export default listMatchListGroup.reducer
